
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Les dix fiches des vaccins les plus connus`}</h1>
    <h2>{`On entend régulièrement leurs noms. Mais de quoi parle-t-on exactement? Notre guide pour s'y retrouver.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;